<template>
	<nut-navbar
		class="navbar"
		title="媒体·播放"
		fixed
		:placeholder="false"
		:left-show="false"
	>
		<template #left>
			<nut-icon
				@click="handleOpenDialog"
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
			>
			</nut-icon>
		</template>
		<template #right v-if="tabVal !== 'html' && !loadConfigErr">
			<nut-icon
				class-prefix="icon"
				font-class-name="iconfont"
				@click="handleOpenSetting"
				name="setting"
				size="18"
			>
			</nut-icon>
		</template>
	</nut-navbar>
	<div class="main">
		<nut-tabs class="tabs" v-model="tabIndexVal">
			<nut-tabpane title="图片·视频" pane-key="0">
				<div class="scroll" id="scrollContainer1">
					<nut-infiniteloading
						containerId="scrollContainer1"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<div>
							<SwipeItem
								v-for="item in playlist"
								:ref="setSwiperRef"
								:key="
									item.id +
									(item.title || item.subtitle) +
									item.on_show
								"
								:item-data="item"
								@left-click="handleOpenDetailModal(item)"
								@delete-success="handleDelete"
								@open="handleSingleOpen"
							/>
						</div>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
			<nut-tabpane title="字幕" pane-key="1">
				<div class="scroll" id="scrollContainer2">
					<nut-infiniteloading
						containerId="scrollContainer2"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<div>
							<SwipeItem
								type="subtitle"
								v-for="item in playlist"
								:key="
									item.id +
									(item.title || item.subtitle) +
									item.on_show
								"
								:item-data="item"
								@delete-success="handleDelete"
								@left-click="handleOpenDetailModal(item)"
							/>
						</div>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
			<nut-tabpane title="音乐" pane-key="2">
				<div class="scroll" id="scrollContainer3">
					<nut-infiniteloading
						containerId="scrollContainer3"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<div>
							<SwipeItem
								type="audio"
								v-for="item in playlist"
								:key="
									item.id +
									(item.title || item.subtitle) +
									item.on_show
								"
								:item-data="item"
								@left-click="handleOpenDetailModal(item)"
							/>
						</div>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
			<nut-tabpane title="游戏" pane-key="3">
				<div class="scroll" id="scrollContainer4">
					<nut-infiniteloading
						containerId="scrollContainer4"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<div>
							<SwipeItem
								type="html"
								v-for="item in playlist"
								:key="item.id + (item.title || item.subtitle)"
								:item-data="item"
								@left-click="handleOpenDetailModal(item)"
							/>
						</div>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
		</nut-tabs>
	</div>
	<nut-drag
		v-if="
			tabVal === 'subtitle' &&
			!detailModalVisible &&
			!visible &&
			!commonVisible
		"
		:style="{ bottom: '100px', right: '16px' }"
	>
		<div @click="$router.push('/subtitle')" class="btn-drag">制作</div>
	</nut-drag>
	<nut-drag
		v-if="
			(tabVal === 'view' || tabVal === 'audio') &&
			!detailModalVisible &&
			!visible &&
			!commonVisible
		"
		:style="{ bottom: '100px', right: '16px' }"
	>
		<div class="btn-drag" @click="$router.push('/upload')">
			<nut-icon
				class-prefix="icon"
				font-class-name="iconfont"
				name="upload"
				:size="28"
			>
			</nut-icon>
		</div>
	</nut-drag>
	<setting-modal
		v-if="visible"
		v-model="visible"
		:type="tabVal"
		:config="playConfig"
		@success="handleSuccess"
	>
	</setting-modal>
	<edit-detail
		v-if="detailModalVisible"
		:type="tabVal"
		:data="currentItemInfo"
		v-model="detailModalVisible"
		:total="playlist.length"
		:colorOptions="colorOptions"
		@success="handleSaveSuccess"
	>
	</edit-detail>
</template>

<script>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import useDialog from '@/hooks/useDialog';
import SettingModal from './components/settingModal.vue';
import EditDetail from './components/detailEdit.vue';
import SwipeItem from './components/swipe.vue';
import {
	MEDIA_PLAY_IMAGE,
	MEDIA_PLAY_TEXT,
	MEDIA_PLAY_MUSIC,
	MEDIA_PLAY_GAME,
} from '@/constants/tiptype';
import { PLAYLIST_TYPE } from '@/constants';
import { playlistApi } from '@/apis';
import { Toast } from '@nutui/nutui';

const tabMap = {
	0: 'view',
	1: 'subtitle',
	2: 'audio',
	3: 'html',
};
const LIMIT = 18;
export default {
	name: 'PlayList', // 媒体播放列表
	components: {
		SettingModal,
		SwipeItem,
		EditDetail,
	},
	setup() {
		const route = useRoute();
		const { handleOpenDialog: open, visible: commonVisible } = useDialog();
		const tabIndexVal = ref(route.query.tab || '0');
		const visible = ref(false);
		const detailModalVisible = ref(false);
		const playlist = ref([]);
		const playConfig = ref({});
		const currentItemInfo = ref({});
		const hasMore = ref(true);
		const offset = ref(0);
		const locked = ref(false);
		const swipeRefs = ref([]);
		const colorOptions = ref([]); // 颜色值选项
		const loadConfigErr = ref(true);
		const tabVal = computed(() => {
			return tabMap[tabIndexVal.value];
		});
		const setSwiperRef = (el) => {
			swipeRefs.value.push(el);
		};
		const handleOpenDialog = () => {
			const typemap = {
				view: MEDIA_PLAY_IMAGE,
				subtitle: MEDIA_PLAY_TEXT,
				audio: MEDIA_PLAY_MUSIC,
				html: MEDIA_PLAY_GAME,
			};
			open(typemap[tabVal.value]);
		};

		const handleOpenDetailModal = (currentItem) => {
			currentItemInfo.value = currentItem;
			detailModalVisible.value = true;
		};

		const getConfig = async () => {
			const res = await playlistApi.playlist_load_config();
			if (!res || Array.isArray(res)) {
				loadConfigErr.value = true;
				return;
			}
			loadConfigErr.value = false;
			playConfig.value = res;
			colorOptions.value = res.color_options;
		};

		const getList = async () => {
			locked.value = true;
			let list = await playlistApi.playlist_load_data({
				type: PLAYLIST_TYPE[tabVal.value],
				offset: offset.value,
				limit: LIMIT,
			});
			if (!Array.isArray(list)) list = []; // 兼容接口存在不会返回空数组情况
			playlist.value =
				offset.value === 0 ? list : [...playlist.value, ...list];
			hasMore.value = list.length >= LIMIT;
			await nextTick();
			locked.value = false;
		};

		const handleSuccess = () => {
			getConfig();
		};

		const handleSaveSuccess = () => {
			getList();
		};

		const handleRefresh = async (done) => {
			offset.value = 0;
			await getList();
			done();
		};

		const handleLoadMore = async (done) => {
			if (locked.value) return;
			offset.value = playlist.value.length;
			await getList();
			done();
		};

		const handleDelete = (id) => {
			const index = playlist.value.findIndex((item) => item.id === id);
			playlist.value.splice(index, 1);
			handleRefresh();
		};

		const handleSingleOpen = (currentRef) => {
			swipeRefs.value.forEach((refItem) => {
				if (currentRef !== refItem.swipeRef) {
					refItem.swipeRef.close();
				}
			});
		};

		const handleOpenSetting = () => {
			if (loadConfigErr.value) {
				Toast.text('数据异常，请刷新后重试');
				return;
			}
			visible.value = true;
		};

		watch(tabIndexVal, () => {
			offset.value = 0;
			playlist.value = [];
			getList();
		});

		onMounted(() => {
			getConfig();
			getList();
		});
		return {
			visible,
			tabVal,
			tabIndexVal,
			playlist,
			playConfig,
			detailModalVisible,
			currentItemInfo,
			hasMore,
			swipeRefs,
			colorOptions,
			commonVisible,
			loadConfigErr,

			setSwiperRef,
			handleSuccess,
			handleOpenDialog,
			handleOpenDetailModal,
			handleSaveSuccess,
			handleRefresh,
			handleLoadMore,
			handleDelete,
			handleSingleOpen,
			handleOpenSetting,
		};
	},
};
</script>

<style lang="scss" scoped>
.main {
	padding: $navbar-height 0 $tabbar-height 0;
}

$h: calc(100vh - $navbar-height - $tabbar-height - 46px);

.tabs {
	:deep(.nut-tabpane) {
		padding: 0;
		height: $h;
		overflow-x: hidden;
	}
}

.btn-drag {
	width: 48px;
	height: 48px;
	@include flex-center;
	justify-content: center;
	border-radius: 24px;
	font-size: 12px;
	background: $primary-color;
	color: #fff;
	opacity: 0.85;
}

.scroll {
	height: $h;
	overflow-y: scroll;
	overflow-x: hidden;
	:deep(.nut-infiniteloading) {
		height: 100%;
	}
}

.nomore {
	font-size: 12px;
	text-align: center;
	color: #999;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>
